import React, { useEffect, useRef, useState } from "react"

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  loadingFallback?: React.ReactNode
}

export function ImageWithLoading({
  loadingFallback,
  onLoad,
  onError,
  style,
  ...props
}: Props) {
  const imgRef = useRef<HTMLImageElement>(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const img = imgRef.current
    if (!props.src) {
      setLoaded(true)
      return
    }
    setLoaded(false)
    if (!img) return
    if (img.complete && img.naturalWidth > 0) {
      setLoaded(true)
    }
  }, [props.src])

  return (
    <>
      {!loaded && loadingFallback}
      <img
        ref={imgRef}
        {...props}
        onLoad={(event) => {
          setLoaded(true)
          onLoad?.(event)
        }}
        onError={(event) => {
          setLoaded(true)
          onError?.(event)
        }}
        style={{
          ...(style ?? {}),
          visibility: loaded ? "visible" : "hidden",
        }}
      />
    </>
  )
}
